require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-glennsl-bs-benchmarkjs.json") })
        }
      }, "path---package-unpublished-glennsl-bs-benchmarkjs");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-glennsl-bs-benchmarkjs!./.cache/json/package-unpublished-glennsl-bs-benchmarkjs.json
// module id = 937
// module chunks = 231608221292675